// src/components/ui/calendar/day/DayViewTimeRow/DayViewTimeRow.jsx
import React from 'react';
import { cn } from '../../../../../utils/cn';
import { CalendarHourLabel } from '../../core';

const DayViewTimeRow = ({
  hour,
  currentDate,
  events = [],
  onTimeSlotClick,
  isAdmin = false,
  children, // For custom content or events
  // Availability props
  hasAvailability = false,
  viewingPartnerAvailability = false,
  // Block mode props
  isBlockMode = false,
  isSelected = false,
  isDragHighlighted = false,
  onSlotMouseDown,
  onSlotMouseEnter,
  className = ''
}) => {
  const handleSlotClick = () => {
    if (isBlockMode) return; // Block mode uses mousedown/mouseup
    if (isAdmin && onTimeSlotClick) {
      onTimeSlotClick(currentDate, hour);
    }
  };

  return (
    <div className={cn(
      "flex border-b border-slate-600/20 h-16",
      className
    )}>
      {/* Hour label */}
      <CalendarHourLabel hour={hour} />

      {/* Hour content with side-by-side events */}
      <div
        className={cn(
          "flex-1 relative h-16 group",
          "transition-colors duration-200",

          // Normal mode cursor
          !isBlockMode && isAdmin && "cursor-pointer",

          // Block mode: selected slot
          isSelected && "bg-blue-500/30 border border-blue-400",

          // Block mode: drag preview highlight
          isDragHighlighted && !isSelected && "bg-blue-400/20 border border-blue-400/50",

          // Block mode: unselected hover
          isBlockMode && !isSelected && !isDragHighlighted && "cursor-crosshair hover:bg-blue-500/10",

          // Availability styling (only outside block mode)
          !isBlockMode && hasAvailability && "bg-purple-600/10 border-l-2 border-purple-500/30",
          !isBlockMode && hasAvailability && "hover:bg-purple-600/20",

          // Default hover (outside block mode, no availability)
          !isBlockMode && !hasAvailability && "hover:bg-slate-700/10"
        )}
        onClick={handleSlotClick}
        onMouseDown={isBlockMode ? onSlotMouseDown : undefined}
        onMouseEnter={isBlockMode ? onSlotMouseEnter : undefined}
      >
        {/* Availability indicator (only outside block mode) */}
        {!isBlockMode && hasAvailability && (
          <div className="absolute top-1 right-1 w-1.5 h-1.5 bg-purple-400 rounded-full"></div>
        )}

        {/* Custom content or events */}
        {children}
      </div>
    </div>
  );
};

export default DayViewTimeRow;